import React, { useEffect } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import { useSuppliers } from 'src/modules/buyer/modules/suppliers/hooks'
import { useActionRunner } from 'src/modules/notification'

import PublicProductView from './PublicProductView'
import PublicSuppliersView from './PublicSuppliersView'
import PublicSingleSupplierView from './PublicSingleSupplierView'

const Public = () => {
  const {
    fetchAllergenFilterChoices,
    fetchCategoryChoices,
    fetchDietaryFilterChoices,
    fetchSustainabilityFilterChoices,
  } = useSuppliers()

  const [fetchData] = useActionRunner([
    fetchAllergenFilterChoices,
    fetchDietaryFilterChoices,
    fetchCategoryChoices,
    fetchSustainabilityFilterChoices,
  ])

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <Switch>
      <Route
        path="/public/suppliers/find"
        exact
        component={PublicSuppliersView}
      />
      <Route
        path="/public/suppliers/:id"
        component={PublicSingleSupplierView}
      />
      <Route path="/public/products/:id" component={PublicProductView} />
      <Redirect to="/public/suppliers/find" />
    </Switch>
  )
}

export default Public
